import $ from 'jquery';

if ($('.training-video-grid-item').length) {
  $(window).on('load', function () {

  $('.searchbar').on('keyup', function () {

    var hash = window.location.hash;
    var hashCategory = hash.replace('#', '');
    var searchInput = ($(this).val());
    var searchQuery = searchInput.toLowerCase();
    //For each card we check if the name matches the input
    $('.training-video-grid-item').each(function () {
      var card = $(this);
      var cardTitle = (card.find('.headline-xs').html()).toLowerCase();
      if ( hashCategory.length ) {
        if (((cardTitle.includes(searchQuery)) && (card.hasClass(hashCategory) || hashCategory == 'all'))) {
          card.each(function () {
            card.removeClass('hide-training-video');
          });
        } else {
          card.addClass('hide-training-video');
        }
      }
      else if (((cardTitle.includes(searchQuery)) || searchQuery === (''))) {
        card.each(function () {
          card.removeClass('hide-training-video');
        });
      } else {
        card.addClass('hide-training-video');
      }
    });
})
})
}
if ($('.mixer-manual-grid-item').length) {
  $(window).on('load', function () {
    var hash = window.location.hash;
    var hashCategory = hash.replace('#', '');

    $('.searchbar').on('keyup', function () {
      var searchInput = ($(this).val());
      var searchQuery = searchInput.toLowerCase();
      //For each card we check if the name matches the input
      $('.mixer-manual-grid-item').each(function () {
        var card = $(this);
        var cardTitle = (card.find('.headline-xs').html()).toLowerCase();

        if ( hashCategory.length ) {
          if (((cardTitle.includes(searchQuery)) && (card.hasClass(hashCategory) || hashCategory == 'all'))) {
            card.each(function () {
              card.removeClass('hide-mixer-manual');
            });
          } else {
            card.addClass('hide-mixer-manual');
          }
        }
        else if ( cardTitle.includes(searchQuery)) {
          card.each(function () {
            card.removeClass('hide-mixer-manual');
          });
        } else {
          card.addClass('hide-mixer-manual');
        }
      });
    })
  })
}
